// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectTradeSessionStatusMessage } from "../../../../Utils/DirectMessages/DirectTradeSessionStatusMessage.js"
import { SessionOperations } from "../../../../Utils/Enums/Constants.js"
export let TradeSessionStatusMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

TradeSessionStatusMessageProcessor.prototype =
    Object.create(MessageProcessorBase.prototype)

TradeSessionStatusMessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory

    var msg = new DirectTradeSessionStatusMessage()
    msg.Id = fieldSet.GetValue(factory.FIELD_ID)
    msg.Name = fieldSet.GetValue(factory.FIELD_NAME)
    msg.IsDecreaseOnlyPositionCount = fieldSet.GetValue(factory.FIELD_IS_DECREASE_ONLY_POSITION_COUNT)

    let operations = fieldSet.GetValue(factory.FIELD_SESSION_ALLOWED_OPERATIONS)
        .split(';')
        .filter(function (el) { return el.length > 0 })

    if (operations.length)
    {
        if (operations[0] !== '0')
        {
            msg.AllowedOperations |= SessionOperations.Open
        }
        if (operations[1] !== '0')
        {
            msg.AllowedOperations |= SessionOperations.Modify
        }
        if (operations[2] !== '0')
        {
            msg.AllowedOperations |= SessionOperations.Cancel
        }
    }

    let types = fieldSet.GetValue(factory.FIELD_SESSION_ALLOWED_ORDER_TYPES)
        .split(';')
        .filter(function (el) { return el.length > 0 })

    let len = types.length
    for (let i = 0; i < len; i++)
    {
        if (types[i] !== '0')
        {
            msg.AllowedOrderTypes.push(i)
        }
    }

    return [msg]
}
